var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-radiogroup", class: _vm.computedClass },
    [
      _vm._l(_vm.radioList, function(item) {
        return _c("Checkbox", {
          key: item[_vm.keyStr],
          staticClass: "component-radiogroup-checkbox",
          class: _vm.CheckboxClass,
          attrs: {
            label: item._ori.label,
            _id: item._ori[_vm.keyStr],
            reverse: _vm.reverse,
            disabled: _vm.disabled
          },
          on: { input: _vm.handleClickItem },
          model: {
            value: item._selected,
            callback: function($$v) {
              _vm.$set(item, "_selected", $$v)
            },
            expression: "item._selected"
          }
        })
      }),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }